import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { getTikTokFollowWelcomeMessageState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import { MESSAGE_SAVED_TEXT, NAMESPACE } from 'apps/tiktokFollowWelcome/store/constants'
import { alert } from 'common/core'
import { tiktokApi } from 'shared/api/requests/tiktok'
import { createAsyncAction } from 'shared/lib/redux'

const updateContentApi = tiktokApi.tikTokFollowWelcome.updateContent

export const updateTikTokMessage = createAsyncAction(
  `${NAMESPACE}/updateMessage`,
  async (message: string) => {
    const updatedData = await tiktokApi.tikTokFollowWelcome.updateContent({ body: { message } })

    alert(MESSAGE_SAVED_TEXT(), 'success')

    return getTikTokFollowWelcomeMessageState(updatedData.data.follow_welcome)
  },
  {
    autoHandleByGuards: [updateContentApi.isContentUpdateFailedError],
  },
)

export const updateTikTokMessageReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  // Only its own fields, so a toggle running at the same time keeps its state
  builder.addCase(updateTikTokMessage.fulfilled, (state, action) => ({
    ...state,
    followWelcome: action.payload.followWelcome,
    auditStatus: action.payload.auditStatus,
  }))
}
